import { extendTheme } from "@chakra-ui/react";
import colors from "./colors";
import colorSchemes from "./colorSchemes";

export const MadrasaTheme = extendTheme({
  colors,
  colorSchemes
})